import { formatRelative } from "date-fns";
import { useDateFnsLocale } from "./useDateFnsLocale";

export function RelativeDate({ date }: { date?: string }) {
  const dateFnsLocale = useDateFnsLocale();
  if (!date) return null;
  return formatRelative(new Date(date), new Date(), { locale: dateFnsLocale });
}
